import {useContext} from 'react';
import {AvailableStatusesContext} from '../components/StatusPicker';

export const useAvailableStatusesContext = () => useContext(AvailableStatusesContext);
